var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPeople = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 250 200"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FDF2F8",
  fillRule: "evenodd",
  d: "M63 134h91q.774-.002 1.5-.161.726.16 1.5.161h52a7 7 0 1 0 0-14h-6a7 7 0 1 1 0-14h19a7 7 0 1 0 0-14h-22a7 7 0 1 0 0-14h-64a7 7 0 1 0 0-14H79a7 7 0 1 0 0 14H39a7 7 0 1 0 0 14h25a7 7 0 1 1 0 14H24a7 7 0 1 0 0 14h39a7 7 0 1 0 0 14m163 0a7 7 0 1 0 0-14 7 7 0 0 0 0 14",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M81 66a6 6 0 0 1 6-6h63.429a6 6 0 0 1 6 6v54.629a6 6 0 0 1-6 6H87a6 6 0 0 1-6-6z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#960145",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M81 66a6 6 0 0 1 6-6h63.429a6 6 0 0 1 6 6v54.629a6 6 0 0 1-6 6H87a6 6 0 0 1-6-6z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinejoin: "round",
  strokeOpacity: 0.2,
  strokeWidth: 3,
  d: "M81 66a6 6 0 0 1 6-6h63.429a6 6 0 0 1 6 6v54.629a6 6 0 0 1-6 6H87a6 6 0 0 1-6-6z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M93.57 78.57a6 6 0 0 1 6-6H163a6 6 0 0 1 6 6v54.63a6 6 0 0 1-6 6H99.57a6 6 0 0 1-6-6z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#960145",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M93.57 78.57a6 6 0 0 1 6-6H163a6 6 0 0 1 6 6v54.63a6 6 0 0 1-6 6H99.57a6 6 0 0 1-6-6z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinejoin: "round",
  strokeOpacity: 0.2,
  strokeWidth: 3,
  d: "M93.57 78.57a6 6 0 0 1 6-6H163a6 6 0 0 1 6 6v54.63a6 6 0 0 1-6 6H99.57a6 6 0 0 1-6-6z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BE185D",
  strokeWidth: 3,
  d: "M151.033 101.5c0 3.854-3.15 7-7.033 7s-7.033-3.146-7.033-7 3.15-7 7.033-7 7.033 3.146 7.033 7ZM129.5 124.875c0-6.198 5.064-11.25 11.3-11.25h6.4c6.236 0 11.3 5.052 11.3 11.25v.625h-29z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#BE185D",
  d: "M124 106c5.883 0 10.667-4.709 10.667-10.5 0-5.79-4.784-10.5-10.667-10.5s-10.667 4.71-10.667 10.5c0 5.791 4.784 10.5 10.667 10.5m4 2.625h-8c-8.824 0-16 7.064-16 15.75V127h40v-2.625c0-8.686-7.176-15.75-16-15.75"
})));
export default SvgPeople;